import { portalHrefForClient } from "./clientAccess";
import { logClientActivity } from "./clientActivity";

export function portalEmailDraft({ client, advisorName = "Your advisor", support = "" }) {
  const kind = client?.role_type === "seller" ? "seller" : "buyer";
  const href = portalHrefForClient(client);
  const subject = `Your ${kind} portal is ready`;
  const body = [
    `Hello ${client?.name || ""},`,
    "",
    `${advisorName} has opened your REChecklist ${kind} portal. This link is only for your checklist.`,
    "",
    `Client ID: ${client?.client_code || ""}`,
    `Portal: ${href}`,
    "",
    "Your information stays with the office. If this note reached you in error, please delete it and contact the office.",
    support ? `Office: ${support}` : "",
  ]
    .filter((line) => line !== "")
    .join("\n");
  const mailto = `mailto:${encodeURIComponent(client?.email || "")}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  return { subject, body, href, mailto };
}

export function copyPortalLink(client, actor) {
  const href = portalHrefForClient(client);
  return navigator.clipboard.writeText(`${href}  (Client ID ${client.client_code})`).then(() => {
    logClientActivity(client.id, "portal_link_copied", {
      actorId: actor?.userId || null,
      href,
      clientCode: client.client_code,
    });
    return href;
  });
}

export function markPortalLinkSent(client, actor) {
  const href = portalHrefForClient(client);
  logClientActivity(client.id, "portal_link_sent", {
    actorId: actor?.userId || null,
    href,
    clientCode: client.client_code,
  });
  return href;
}
